import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JornadaPonto } from '../../api.service';

@Component({
  selector: 'app-grade-jornadas-relogio',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './grade-jornadas-relogio.component.html'
})
export class GradeJornadasRelogioComponent {
  @Input() jornadas: JornadaPonto[] = [];

  @Output() selecionar = new EventEmitter<string>();
}
